import { render, staticRenderFns } from "./PrintTickets.vue?vue&type=template&id=9fc45026&"
import script from "./PrintTickets.vue?vue&type=script&lang=js&"
export * from "./PrintTickets.vue?vue&type=script&lang=js&"
import style0 from "./PrintTickets.vue?vue&type=style&index=0&id=9fc45026&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports